"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class CustomStatusController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            createInAlert: '/v1/alertStatus',
            editInAlert: '/v1/alertStatus/:objectId',
            deleteInAlert: '/v1/alertStatus/:objectId',
            createInCase: '/v1/caseStatus',
            editInCase: '/v1/caseStatus/:objectId',
            deleteInCase: '/v1/caseStatus/:objectId',
        };
    }
    createIn(typeEntity, data) {
        return this.manager.post({
            url: typeEntity === 'case' ? this.endpoints.createInCase : this.endpoints.createInAlert,
        }, data);
    }
    editIn(typeEntity, data, objectId) {
        return this.manager.patch({
            url: typeEntity === 'case' ? this.endpoints.editInCase : this.endpoints.editInAlert,
            params: { objectId },
        }, data);
    }
    deleteIn(typeEntity, objectId) {
        return this.manager.delete({
            url: typeEntity === 'case' ? this.endpoints.deleteInCase : this.endpoints.deleteInAlert,
            params: { objectId },
        });
    }
}
exports.default = CustomStatusController;
